import React from "react";
import { Link } from "react-router-dom";
import { Card,  Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";

import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

const ProductsCount = ({ data }) => {
  const cardStyles = {
    "Products": { color: "#A45EE5", icon: Inventory2OutlinedIcon, link: "/products-list" },
    "Product Types": { color: "#03AC13", icon: CategoryOutlinedIcon, link: "/product-types" },
    "Brands": { color: "#e53935", icon: LocalOfferOutlinedIcon, link: "/brands" },
    "Regions": { color: "#3f51b5", icon: LocationOnOutlinedIcon, link: "/regions" },
  };

  return (
    <Card>
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: "16px", md: "18px" },
          fontWeight: 700,
          textAlign: "center",
          p: 1,
        }}
        className="text-black"
      >
        Product Details
      </Typography>
      <Grid container spacing={2} sx={{ p: 2 }}>
        {data &&
          Object.entries(data).map(([name, value]) => {
            const { color, icon: Icon, link } =
              cardStyles[name] || {
                color: "#00897b",
                icon: FolderOutlinedIcon,
                link: "/dashboard",
              };

            return (
              <Grid item key={name} size={{ xs: 6 }}>
                <Link
                  to={link}
                  style={{ textDecoration: "none" }}
                >
                  <Card
                    sx={{
                      boxShadow: "none",
                      borderRadius: "7px",
                      padding: { xs: "18px", sm: "20px", lg: "25px" },
                      backgroundColor: color,
                      color: "white",
                      position: "relative",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      "&:hover": {
                        opacity: 0.9,
                      },
                    }}
                    className="rmui-card"
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255, 255, 255, 0.06)",
                        top: "-20px",
                        right: "-20px",
                        zIndex: 0,
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        width: "150px",
                        height: "150px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255, 255, 255, 0.14)",
                        bottom: "-50px",
                        left: "-50px",
                        zIndex: 0,
                      }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        zIndex: 1,
                      }}
                    >
                      <Box sx={{ mr: 2, display: "flex", alignItems: "center" }}>
                        <Icon sx={{ fontSize: 40 }} />
                      </Box>
                      <Box>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            opacity: 0.8,
                            color: "white",
                          }}
                        >
                          {name}
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: 24,
                            fontWeight: 700,
                            color: "white",
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Link>
              </Grid>
            );
          })}
      </Grid>
    </Card>
  );
};

export default ProductsCount;